import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  gridContainer: {
    height: '100%',

    '& .browse-progressLine': {
      paddingTop: 24,
    },
  },
  browseSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    width: '100%',
    minHeight: 'calc(100% - 60px)',
    fontFamily: Theme.typography.base.regular,
    maxWidth: '1080px',
  },
  browseSummaryCardWrapper: {
    padding: '0 16px',
    [Theme.breakpoints.up('sm')]: {
      padding: '0 30px',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '0 50px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '0',
    },
  },
  browseSummaryWrapper: {
    paddingLeft: '180px',
    paddingRight: '180px',
    [Theme.breakpoints.down('lg')]: {
      paddingLeft: '50px',
      paddingRight: '50px',
    },
    [Theme.breakpoints.down('sm')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  browseSummaryTitle: {
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[9],
    lineHeight: '150%',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[7],
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[6],
    },
  },
  browseSummaryDescription: {
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[3],
    lineHeight: '145%',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[2],
    },
  },
  browseSummaryCtaWrapper: {
    marginTop: '30px',
    marginLeft: 'auto',
    marginRight: '50px',
    [Theme.breakpoints.down('sm')]: {
      margin: '20px 30px 0 30px',
      width: 'auto',
    },
    [Theme.breakpoints.down('xs')]: {
      margin: '20px 16px 0 16px',
    },
    [Theme.breakpoints.up('xl')]: {
      marginRight: '0',
    },
  },
  browseSummaryCta: {
    background: Theme.palette.gray[500],
    borderRadius: '3px',
    color: Theme.palette.white,
    padding: '14px 30px',
    [Theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  notification: {
    margin: '10px 0px 40px 0px',
    borderRadius: '5px',
  },
  notificationSlot: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '10px 0px',
    [Theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    '& button': {
      width: 'fit-content',
      position: 'relative',
      height: '32px',
      fontSize: Theme.typography.size[1],
      bottom: '16px',
      right: '40px',
      [Theme.breakpoints.down('md')]: {
        bottom: '0px',
        right: 'initial',
      },
    },
  },
  notificationDesc: {
    width: '60%',
    [Theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

export default useStyles;
